// src/api/commonApi.js
import axios from 'axios';

export const shortlistedPropertyApi = async ({ id, status, user, token }) => {
  if (!user?.data?.id) {
    return { loginRequired: true };
  }

  try {
    const formData = new FormData();
    formData.append("property_id", id);
    formData.append("user_id", user.data.id);
    formData.append("name", user.data.name);
    formData.append("mobile", user.data.mobile);
    formData.append("activity_category", "shortlisted_property");
    formData.append("status", status);

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/shortlistedProperty`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error in shortlistedProperty API:", error);
    return { error: true };
  }
};


export const sendWhatsappMessageApi = async ({ slug,mobile,name,link,title,location, token ,user_mobile='',user_name='',user_address='',user_email=''}) => {
  // if (!mobile || !token) {
  //   return { error: true, message: "Mobile number and token are required." };
  // }

  try {

   
    const baseUrl = window.location.origin;
    const fullLink = link ? baseUrl + link : '';
    
    // Create FormData
    const formData = new FormData();
    formData.append("slug", slug);
    formData.append("name", name);
    formData.append("mobile", mobile);
    formData.append("title", title);
    formData.append("location", location);
    
    if (link) {
        formData.append("link", fullLink);
    }
   
    formData.append("user_mobile", user_mobile);
    formData.append("user_name", user_name);
    formData.append("user_address", user_address);
    formData.append("user_email", user_email);
    


    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/whatsapp/messaging`, // adjust this to your actual route
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error in sendWhatsappMessage API:", error);
    return { error: true };
  }
};




export const downloadFile = (url, filename = "Download.pdf") => {
    if (!url) {
      console.warn("No URL provided for download.");
      return;
    }
  
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };